import { gql } from '@grandvisionhq/graphql';
import StoreFragment from '../fragments/store.js';
import StoreInventoryFragment from '../fragments/store-inventory.js';
import StoreOffersFragment from '../fragments/store-offers.js';
import StoreReservabilityFragment from '../fragments/store-reservability.js';
import StoresFilter from '../fragments/stores-filter.js';

const STORES_SEARCH_WITHOUT_INVENTORY = gql`
  query StoresSearchWithoutInventory($input: StoresSearchInput) {
    availableFilters: storesSearch {
      filters {
        ...StoresFilter
      }
    }
    filteredResults: storesSearch(input: $input) {
      results {
        ...Store
      }
      filters {
        ...StoresFilter
      }
    }
  }
  ${StoreFragment}
  ${StoresFilter}
`;
const STORES_SEARCH_WITH_INVENTORY = gql`
  query StoresSearchWithInventory($input: StoresSearchInput, $sku: ID!) {
    availableFilters: storesSearch {
      filters {
        ...StoresFilter
      }
    }
    filteredResults: storesSearch(input: $input) {
      results {
        ...Store
        ...StoreInventory
        ...StoreReservability
        ...StoreOffers
      }
      filters {
        ...StoresFilter
      }
    }
  }
  ${StoreFragment}
  ${StoreInventoryFragment}
  ${StoreReservabilityFragment}
  ${StoreOffersFragment}
  ${StoresFilter}
`;

export { STORES_SEARCH_WITHOUT_INVENTORY, STORES_SEARCH_WITH_INVENTORY };
//# sourceMappingURL=stores-search.js.map
